import useTranslation from 'next-translate/useTranslation'

import BodyText from '../../../../app/components/BodyText'
import useAppDispatch from '../../../../../store/hooks/useAppDispatch'
import useAppSelector from '../../../../../store/hooks/useAppSelector'
import useOutletPickerTimes from '../../../../outlet/hooks/useOutletPickerTimes'
import getFormattedOrderTimeSlot from '../../../../outlet/utils/getFormattedOrderTimeSlot'
import { outletsSelectedOutletListItemSelector } from '../../../../outlets/store/outletsSelectors'
import {
  preOrderNewOrderDateSelector,
  preOrderNewOrderOrderFormatSelector,
  preOrderNewOrderTimeSelector,
} from '../../../store/preOrderSelectors'
import { setNewOrderDetails } from '../../../store/preOrderSlice'
import PanelOptionList from '../PanelOptionList'

export default function TimeStep() {
  const { t } = useTranslation('preOrder')
  const dispatch = useAppDispatch()

  const outlet = useAppSelector(outletsSelectedOutletListItemSelector)
  const orderFormat = useAppSelector(preOrderNewOrderOrderFormatSelector)
  const orderDate = useAppSelector(preOrderNewOrderDateSelector)
  const orderTime = useAppSelector(preOrderNewOrderTimeSelector)

  const pickerTimes = useOutletPickerTimes(outlet, orderFormat, orderDate)

  if (!pickerTimes.length) {
    return (
      <BodyText color="body-1">{t('newOrderPanel.noTimesAvailable')}</BodyText>
    )
  }

  return (
    <PanelOptionList
      ariaLabel={t('newOrderPanel.steps.time')}
      selectedId={orderTime != null ? String(orderTime) : null}
      onSelect={id => dispatch(setNewOrderDetails({ orderTime: Number(id) }))}
      options={pickerTimes.map(pickerTime => ({
        id: String(pickerTime.timestamp),
        label: getFormattedOrderTimeSlot(pickerTime.timestamp),
      }))}
    />
  )
}
